import React from 'react'
import { Query, QueryResult } from 'react-apollo'
import gql from 'graphql-tag'
import { compact } from 'lodash'
import { Classes } from '@blueprintjs/core'
import { HeroCards } from '@ui'
import css from './dashboard.module.scss'

const query = gql`
  query companyCounters($cities: [String]) {
    viewer {
      company {
        counters(cities: $cities) {
          cities
          buildings
          employees
          floors
          sqft
          workstations
        }
      }
    }
  }
`

interface IPayload {
  viewer: {
    company: {
      counters: {
        buildings: number
        employees: number
        floors: number
        sqft: number
        workstations: number
        cities: number
      }
    }
  }
}

interface IVariables {
  cities: string[]
}

interface ICounter {
  value: number
  label: string
}

export default function CompanyCounters({ city }: { city: string | null }) {
  return (
    <HeroCards>
      <Query notifyOnNetworkStatusChange query={query} variables={{ cities: compact([city]) }}>
        {({ loading, data }: QueryResult<IPayload>) => {
          if (loading || !data?.viewer)
            return <div className={`${css.placeholder} ${Classes.SKELETON}`} />

          const { cities, buildings, employees, floors, sqft, workstations } =
            data.viewer.company.counters

          const counters: ICounter[] = [
            {
              value: buildings,
              label: buildings === 1 ? 'building' : 'buildings',
            },
            { value: floors, label: floors === 1 ? 'floor' : 'floors' },
            { value: employees, label: 'total employees' },
            {
              value: workstations,
              label: workstations === 1 ? 'seat' : 'seats',
            },
            { value: sqft, label: 'sqft' },
          ]

          if (!city) {
            counters.unshift({
              value: cities,
              label: cities === 1 ? 'city' : 'cities',
            })
          }

          return (
            <>
              {counters.map((c, i) => (
                <HeroCards.Card key={`hero-cards-${i}`} {...c} />
              ))}
            </>
          )
        }}
      </Query>
    </HeroCards>
  )
}
